import axios from "axios";
import config from "../config";
import { GetDecryptAccessTokenformat } from "../Components/Common/Common";
import { trackRequests } from "./requestTracker";

/**
 * Shared axios instance (N-07).
 *
 * Adds:
 *  - a 30s default timeout so hung backends can't pin UI loading state forever
 *  - an Authorization header set from the current access token on every request
 *  - a response interceptor that logs transport errors via the structured
 *    logger (so they are silent in production but visible in dev)
 *
 * Sets these as global axios defaults too, so the existing ~128 `axios.*`
 * call sites in `authSlice.js` / `RequestsAuthSlice.js` benefit without
 * needing to migrate each one. New code should import `apiClient` by default.
 */

const TIMEOUT_MS = 30_000;

axios.defaults.timeout = TIMEOUT_MS;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error?.config?.url;
    const status = error?.response?.status;
    const code = error?.code;
    
    return Promise.reject(error);
  }
);

const apiClient = axios.create({
  baseURL: config.api.base,
  timeout: TIMEOUT_MS,
  headers: { "Content-Type": "application/json" },
});

// Feed the route loader (Components/Loader/RouteLoader).
trackRequests(axios);
trackRequests(apiClient);

apiClient.interceptors.request.use((cfg) => {
  const token = GetDecryptAccessTokenformat();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default apiClient;
